module.exports = __webpack_public_path__ + "img/btn.74605932.png";